import React from 'react'
import { useState } from 'react'

export default function useDrawer() {
  const [isOpen, toggle] = useState(false)
  function toggleDrawer() {
    isOpen ? toggle(false) : toggle(true)
  }
  return [isOpen,toggleDrawer] as const
}

